export var PREDEFINED_TRIPLETS = [
    [0, 2, 5],
    [0, 2, 6],
    [0, 3, 1],
    [0, 3, 8],
    [0, 4, 6],
    [0, 4, 9],
    [0, 5, 8],
    [0, 6, 3],
    [0, 6, 7],
    [0, 7, 1],
    [0, 7, 9],
    [0, 8, 7],
    [1, 0, 2],
    [1, 0, 9],
    [1, 4, 3],
    [1, 4, 6],
    [1, 5, 2],
    [1, 5, 6],
    [1, 5, 7],
    [1, 6, 0],
    [1, 6, 2],
    [1, 6, 7],
    [1, 8, 0],
    [1, 8, 6],
    [1, 9, 8],
    [2, 1, 4],
    [2, 3, 0],
    [2, 4, 0],
    [2, 4, 5],
    [2, 4, 7],
    [2, 4, 8],
    [2, 8, 3],
    [2, 9, 3],
    [2, 9, 4],
    [2, 9, 6],
    [3, 0, 4],
    [3, 1, 5],
    [3, 2, 1],
    [3, 4, 5],
    [3, 5, 0],
    [3, 5, 6],
    [3, 6, 1],
    [3, 7, 6],
    [3, 7, 9],
    [3, 8, 9],
    [3, 9, 4],
    [4, 1, 0],
    [4, 1, 7],
    [4, 1, 8],
    [4, 2, 3],
    [4, 5, 0],
    [4, 5, 1],
    [4, 6, 3],
    [4, 7, 3],
    [4, 7, 9],
    [5, 0, 1],
    [5, 2, 9],
    [5, 2, 9],
    [5, 3, 2],
    [5, 4, 9],
    [5, 6, 0],
    [5, 7, 2],
    [5, 7, 4],
    [5, 7, 8],
    [5, 8, 1],
    [5, 8, 2],
    [5, 8, 3],
    [5, 8, 4],
    [5, 9, 3],
    [5, 9, 6],
    [6, 3, 2],
    [6, 3, 9],
    [6, 4, 2],
    [6, 4, 5],
    [6, 5, 2],
    [6, 5, 7],
    [6, 7, 2],
    [6, 8, 3],
    [6, 9, 4],
    [7, 0, 4],
    [7, 1, 3],
    [7, 1, 8],
    [7, 2, 0],
    [7, 2, 1],
    [7, 3, 0],
    [7, 3, 2],
    [7, 4, 8],
    [7, 5, 0],
    [7, 6, 4],
    [7, 8, 2],
    [7, 9, 2],
    [8, 0, 4],
    [8, 2, 0],
    [8, 2, 1],
    [8, 3, 1],
    [8, 3, 7],
    [8, 4, 3],
    [8, 4, 6],
    [8, 4, 9],
    [8, 5, 6],
    [8, 6, 0],
    [8, 6, 2],
    [8, 6, 7],
    [8, 9, 0],
    [8, 9, 2],
    [9, 0, 3],
    [9, 1, 2],
    [9, 1, 4],
    [9, 1, 5],
    [9, 1, 6],
    [9, 1, 7],
    [9, 2, 0],
    [9, 3, 1],
    [9, 5, 0],
    [9, 5, 7],
    [9, 6, 0],
    [9, 6, 7],
    [9, 7, 8],
    [9, 8, 5],
    [9, 8, 6],
];
